import * as S from "@components/navbar/style/MobileNavbar.styled";
import { INavMenuItem } from "@types";
import React from "react";

interface MenuItemProps {
  item: INavMenuItem;
  level?: number;
  openMenus: Record<string, boolean>;
  toggleMenu: (text: string) => void;
  onCloseMenu: () => void;
  pathname: string;
}

export const MenuItem: React.FC<MenuItemProps> = ({
  item,
  level = 0,
  openMenus,
  toggleMenu,
  onCloseMenu,
  pathname,
}) => {
  if (!item.isAllow) return null;

  const hasSubs = item.subs && item.subs.length > 0;
  const isOpen = openMenus[item.text];

  return (
    <React.Fragment>
      {hasSubs ? (
        <S.AccordionHeader
          onClick={() => toggleMenu(item.text)}
          $active={pathname.includes(item.to)}
          $level={level}
        >
          {item.icon}
          <span>{item.name}</span>
          <S.Arrow $open={isOpen} />
        </S.AccordionHeader>
      ) : (
        <S.SidebarLink
          to={item.to}
          $active={pathname.includes(item.to)}
          onClick={onCloseMenu}
          $level={level}
        >
          {item.icon}
          <span>{item.name}</span>
        </S.SidebarLink>
      )}

      {hasSubs && isOpen && (
        <S.Submenu $open={isOpen}>
          {item.subs!.map((sub, index) => (
            <MenuItem
              key={index + sub.text}
              item={sub}
              level={level + 1}
              openMenus={openMenus}
              toggleMenu={toggleMenu}
              onCloseMenu={onCloseMenu}
              pathname={pathname}
            />
          ))}
        </S.Submenu>
      )}
    </React.Fragment>
  );
};
